import { Directive, HostListener, Input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[ridangoPrefill]',
})
export class PrefillDirective implements OnInit {
    private prefix: string;

    @Input() ridangoPrefill = '';

    @Input() separator = '|';

    constructor(private ngControl: NgControl) {}

    ngOnInit(): void {
        this.prefix = `${this.ridangoPrefill} ${this.separator} `;
        this.ngControl.control.setValue(this.prefix);
    }

    @HostListener('input') inputChange() {
        const val = this.ngControl.value;

        if (!val.startsWith(this.prefix)) {
            this.ngControl.control.setValue('');
            this.ngControl.valueAccessor.writeValue(this.prefix);
        } else {
            const newValue = val;
            this.ngControl.control.setValue(val.replace(this.prefix, ''));
            this.ngControl.valueAccessor.writeValue(newValue);
        }
    }
}
